module.exports = (word, { doTrim = false } = {}) => {
  const sanitized = word.replace(/[^A-Za-z ]/g, "");
  return doTrim ? sanitized.trim() : sanitized;
}
